import React, { FC } from 'react';
import { Select } from '../components/Inputs';
import { ControllerProps } from 'react-hook-form/dist/types/props';
import { useUserRoleQuery } from '../api';

interface UserRoles extends Pick<ControllerProps<'input'>, 'control' | 'name' | 'rules'> {
  label: string;
  error: boolean | undefined;
}

const UserRoles: FC<UserRoles> = ({ label, error, control, name, rules }) => {
  const { data } = useUserRoleQuery();
  return (
    <Select
      label={label}
      data={(data && data.userRoles) || []}
      control={control}
      error={error}
      name={name}
      rules={rules}
    />
  );
};

export default UserRoles;
